import audraPic from "@/public/images/artists/audra.png";
import { Artist } from "@/types/types";

export const audra = {
  id: "197",
  name: "Audra",
  image: audraPic,
  description: `Audra's voice sparkles with clear enunciation and a playful vibrato. It sits at a comfy medium pitch, flows with a steady cadence, and boasts a balanced range—all wrapped in a bright, breezy timbre that fits any tune.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Faudra-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Folk", "Unprocessed", "Indie", "Pop"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 55,
        high: 69,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
